import Instance from './instance.js'

/**
 * Represents a InstanceNull instance.
 * @extends Instance
 */
class InstanceNull extends Instance {
}

export default InstanceNull
